module.exports = __webpack_public_path__ + "query-ai.svg?6bdd6501048328a4a5f7af0dbec8ac18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/query-ai.svg
// module id = 318
// module chunks = 2